export enum PromotionType {
    Undefined = 0,
    FixedDiscount = 1,
    PercentageDiscount = 2,
    NewPrice = 3,
    Budget = 4
}
